import { Link } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { ValuesMarquee } from "../components/ValuesMarquee";
import { CTABand } from "../components/CTABand";
import { Reveal, SectionHeading } from "../components/Reveal";
import { Hero } from "../components/home/Hero";

const Welcome = () => (
  <section data-testid="home-welcome" className="py-24 lg:py-32 bg-white overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <SectionHeading title="Welcome to BMS Health Care Services" />
          <Reveal delay={0.15}>
            <div className="mt-6 space-y-5 text-lg leading-relaxed text-slate-600">
              <p>
                We help individuals live safely, comfortably, and independently at home through compassionate, personalized care. Whether you need a few hours of support each week or around-the-clock assistance, our team is here for you and your family.
              </p>
              <p>
                Proudly serving Surrey, Vancouver, White Rock, Langley, Delta, Richmond, Burnaby, New Westminster, and Coquitlam, BMS combines professional healthcare with the warmth of a locally owned, community-focused team.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-9 flex flex-wrap gap-4">
              <Link
                to="/about"
                data-testid="welcome-about-link"
                className="inline-flex items-center gap-2 rounded-full bg-brand-navy px-6 py-3.5 text-base font-bold text-white hover:bg-brand-teal transition-colors duration-300 active:scale-95"
              >
                Learn More About Us
              </Link>
              <Link
                to="/services"
                data-testid="welcome-services-link"
                className="inline-flex items-center gap-2 rounded-full border border-brand-navy/20 px-6 py-3.5 text-base font-bold text-brand-navy hover:bg-brand-navy hover:text-white transition-colors duration-300 active:scale-95"
              >
                Explore Our Services
              </Link>
            </div>
          </Reveal>
        </div>
        <Reveal className="relative">
          <div className="absolute -top-6 -left-6 w-40 h-40 rounded-3xl bg-brand-mist -z-0" />
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_24px_60px_rgb(11,27,61,0.14)]">
            <img
              src="https://images.pexels.com/photos/7545219/pexels-photo-7545219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200"
              alt="Caregiver sharing a warm moment with an elderly couple in their home"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-8 -right-4 sm:right-8 bg-brand-navy text-white rounded-2xl px-7 py-5 shadow-[0_16px_40px_rgb(11,27,61,0.35)]">
            <p className="font-display italic text-2xl text-brand-cyan">24/7</p>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] mt-1 text-slate-300">Care & Support</p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <ValuesMarquee />
        <Welcome />
        <CTABand />
      </main>
      <Footer />
    </div>
  );
}
